<div class="row">
    <!--Team Dashboard Section User Info-->
    <div class="col-8">
        <div class="card border h-275px rounded-0">
            <div class="row">
                <div class="col-md-6">
                    <div class="imagealignment">
                        <img src="assets/common/images/Activities/bluebackground.svg" alt="logo" width="320" />
                    </div>
                    <div class="floating_content">
                        <div>
                            Welcome To Your,
                        </div>
                        <h4>
                            Dashboard!
                        </h4>
                        <div class="mt-10">
                            Thursday, Nov 12, 2020
                        </div>
                        <div>
                            <span>
                                <img src="assets/common/images/Activities/weatherIcon.png" alt="logo" width="20" />

                            </span>
                            <span>
                                Santa Clara
                            </span>
                        </div>
                    </div>

                </div>

                <div class="col-md-6">
                    <img src="assets/common/images/Activities/TeamDashboard.svg" alt="logo" width="320" class="mt-5" />
                </div>
            </div>
        </div>


        <div class="row top_card_section mt-3">
            <div class="col-md-6 col-lg-3  pb-2 " *ngFor="let item of  leavesCards; let i = index">
                <div class="card shadow-sm card-stretch h-50px rounded-0">
                    <div class="card-body p-1">
                        <div class="row align-items-center no-gutters">
                            <div class="col-4">
                                <div class="align-items-center text-center p-2  ml-4 w-40px rounded">
                                    <img [src]="item.icon" class="img-fluid">
                                </div>
                            </div>
                            <div class="col-8">
                                <div>
                                    <div class="font-size-14 font-weight-bold" style="color: #c6c2c2;">
                                        {{item.name}}
                                    </div>
                                    <div>
                                        <span class="font-size-20 font-weight-bolder {{item.class}}">
                                            {{item.price}}
                                        </span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-4">
        <div class="card shadow-sm h-400px border rounded-0">
            <div class="row h4 font-weight-bold border-bottom px-8 mt-3 pb-3">
                <div>
                    <div class="text-center">
                        <img src="../../../../assets/common/images/Activities/BillableProject.svg" class="h-20px w-20px" />

                    </div>

                </div>
                <div class="col-md-10">
                    {{"Billable" | localize}} / {{"NonBillable" | localize}} Employees
                </div>

            </div>

            <div class="row pt-3 px-5">
                <div class="col-md-1">
                    <div class="symbol symbol-success symbol-sm-20 mr-4">
                        <div class="symbol-label font-weight-boldest"></div>
                    </div>
                </div>
                <div class="col-md-6 font-weight-bolder">
                    Billable
                </div>
                <div class="col-md-4 font-weight-bolder">
                    38 Projects
                </div>
            </div>

            <div class="row pt-3 px-5">
                <div class="col-md-1">
                    <div class="symbol symbol-danger symbol-sm-20 mr-4">
                        <div class="symbol-label font-weight-boldest"></div>
                    </div>
                </div>
                <div class="col-md-6 font-weight-bolder">
                    Non-Billable
                </div>
                <div class="col-md-4 font-weight-bolder">
                    12 Projects
                </div>
            </div>

            <!--<ngx-charts-advanced-pie-chart [view]="view"
                                           [scheme]="colorScheme"
                                           [results]="single"
                                           [gradient]="gradient">
            </ngx-charts-advanced-pie-chart>-->
            <div class="overflow-hidden">
                <ngx-charts-pie-chart [view]="view"
                                      [scheme]="colorScheme"
                                      [results]="series"
                                      [legend]="false"
                                      [labels]="false"
                                      [doughnut]="true"
                                      [legendPosition]="'bottom'"
                                      [legendTitle]="''">
                </ngx-charts-pie-chart>
            </div>







            <div class="row  border-top mt-10">
                <div class="col-12">
                    <div class="text-center text-primary p-3">View Full Report</div>

                </div>
            </div>
        </div>
    </div>

</div>


<div class="row mt-3">
    <!--Team Dashboard New Joinee Sections-->
    <div class="col-md-3 mb-3">
        <div class="card  border shadow-sm rounded-0">
            <div class="no-gutters ml-3 row border-bottom mt-3">
                <div class="col-md-1">
                    <img src="../../../../assets/common/images/Activities/newJoineeicon.svg" class="h-20px w-20px" />

                </div>
                <div class="col-md-11">
                    <div class="font-weight-bolder h6">
                        New Joinees
                    </div>
                </div>

            </div>


            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>
            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/Activities/boyIcon.svg" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>
            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>

            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>

            <div class="row no-gutters ml-3 mb-3">
                <div class="text-primary font-weight-bolder">
                    View All (6)
                </div>
            </div>
        </div>
    </div>

    <!--Birthdays Section-->
    <div class="col-md-3">
        <div class="card border mb-4 shadow-sm rounded-0">
            <div class="no-gutters ml-3 row border-bottom mt-3 pb-2">
                <div class="col-md-1">
                    <img src="../../../../assets/common/images/Activities/birthdayicon.svg" class="h-20px w-20px" />

                </div>
                <div class="col-md-11">
                    <div class="font-weight-bolder h6">
                        Birthdays
                    </div>
                </div>

            </div>

            <div class="row  no-gutters">
                <div class="image-alignment">
                    <img src="../../../../assets/common/images/Activities/birthdaysection.svg" alt="logo" class="img-fluid" />
                </div>
                <div class="floating-context mt-3">
                    <div class="font-size-14 font-weight-bolder text-primary">
                        October
                    </div>
                    <div class="font-size-14 font-weight-bolder text-primary">
                        Birthdays
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>
            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>
            <div class="row mt-4">
                <div class="col displayDepartment px-7">
                    <ul class="detailsdepart_ul">
                        <li class="icon_li">
                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />
                        </li>
                        <li class="content_li">
                            <b>
                                John Doe
                            </b>
                            <br />
                            <small class="text-muted">
                                Program Manager
                            </small>
                            <br />
                            <small>
                                <b>
                                    91-7878782389
                                </b>
                            </small>
                        </li>
                    </ul>



                </div>

            </div>



            <div class="row no-gutters ml-3 mb-3">
                <div class="text-primary font-weight-bolder">
                    View All (6)
                </div>
            </div>
        </div>

    </div>
    <!--Projects Section-->
    <div class="col-md-6">
        <div class="card h-375px  border shadow-sm rounded-0">
            <div class="no-gutters ml-3 row border-bottom mt-3 pb-2">
                <div class="col-md-1">
                    <img src="../../../../assets/common/images/Activities/birthdayicon.svg" class="h-20px w-20px" />

                </div>
                <div class="col-md-11">
                    <div class="font-weight-bolder h6">
                        Projects
                    </div>
                </div>

            </div>
            <div class="row px-4 pt-5">
                <div id="Birthday-data-table">
                    <p-table [value]="Products">
                        <ng-template pTemplate="header">
                            <tr [ngClass]="'textcolor'">
                                <th>Project Name</th>
                                <th>Employees</th>
                                <th>Deadline</th>
                                <th>Status</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-Products>
                            <tr [ngClass]="'textcolor'">
                                <td>
                                    <div class="row no-gutters gutters">
                                        <div class="col-md-3">
                                            <img alt="Pic" src="../../../../assets/common/images/Activities/ProjectIcon.svg" height="30" />

                                        </div>
                                        <div class="col-md-7 ml-3">
                                            {{Products.Name}}
                                        </div>

                                    </div>

                                </td>
                                <td>

                                    <div class="symbol-group  symbol-hover">
                                        <div class="symbol symbol-sm-20 symbol-circle">
                                            <img alt="Pic" src="../../../../assets/common/images/time-sheet/boy_pic.png" />
                                        </div>
                                        <div class="symbol symbol-sm-20 symbol-circle">
                                            <img alt="Pic" src="../../../../assets/common/images/time-sheet/boy_pic.png" />
                                        </div>
                                        <div class="symbol symbol-sm-20 symbol-circle">
                                            <img alt="Pic" src="../../../../assets/common/images/time-sheet/boy_pic.png" />
                                        </div>
                                        <!--<div class="symbol symbol-sm-20 symbol-circle">
                                            <img alt="Pic" src="../../../../assets/common/images/time-sheet/boy_pic.png" />
                                        </div>
                                        <div class="symbol symbol-sm-20 symbol-circle">
                                            <img alt="Pic" src="../../../../assets/common/images/time-sheet/boy_pic.png" />
                                        </div>-->
                                        <!--<div class="symbol symbol-circle symbol-light-danger">
                                            <span class="symbol-label font-weight-bold">5+</span>
                                        </div>-->
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        {{Products.date}}
                                    </div>
                                    <div>
                                        {{Products.time}}
                                    </div>
                                </td>
                                <td>
                                    <div class="label  rounded-pill h-28px w-95px label-inline border  bg-white  justify-content-center" [ngClass]="{'border-primary': Products.Status == 'In Progress','border-warning': Products.Status == 'Pending'}">

                                        <span class="label label-dot label-warning" [ngClass]="{'label-success': Products.Status == 'In Progress','label-warning': Products.Status == 'Pending' }"></span>
                                        <span class="ml-2">{{Products.Status}}</span>

                                    </div>

                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <div class="row no-gutters ml-3 mb-3">
                <div class="text-primary font-weight-bolder">
                    View All (6)
                </div>
            </div>
        </div>

    </div>
</div>



<!--Dropdowns and filter option-->
<div class="row mt-3">
    <div class="col-md-3">
        <div>

            <app-organization-unit-filter [multiselect]="true" [closeOnSelect]="true" [placeholder]="'Filter By Organization Unit'"></app-organization-unit-filter>

        </div>
    </div>

    <div class="col-md-4">
        <app-project-filter [multiselect]="true" [closeOnSelect]="true" [placeholder]="'Filter By Project'"></app-project-filter>
    </div>


    <div class="col-md-4">
        <app-member-filter [multiselect]="true" [closeOnSelect]="true" [placeholder]="'Filter By User'"></app-member-filter>
    </div>

  <!--  <div>
        <button (click)="toggleShow()" class="table_view" type="button" checked>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-task" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z" />
                <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z" />
                <path fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z" />
            </svg>
        </button>
        <button (click)="toggleShow_grid()" class="grid_view border border-left">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid" viewBox="0 0 16 16">
                <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z" />
            </svg>
        </button>
    </div>-->


</div>




<!--Team Details cards Section-->
<div class="card  mb-4  rounded-0">
    <div *ngIf="isShown">
        <div class="row px-3 pt-4 border-bottom">

            <div class="col-md-11">
                <div class="row px-4">

                    <div class="font-weight-bolder h6 text-left ml-3">
                        Team Details
                    </div>
                </div>


            </div>
            <div class="col-md-1">
                <div class="font-weight-bolder text-primary text-center">
                    View All
                </div>
            </div>
        </div>


        <div class="row px-7 pt-5">
            <div id="teamDetails-data-table">
                <p-table [value]="teamDetails">
                    <ng-template pTemplate="header">
                        <tr [ngClass]="'textcolor'">
                            <th style="width: 23%;">Member Name</th>
                            <th>Active Projects</th>
                            <th style="width: 12%;">Productive Time</th>
                            <!--   <th style="width: 10%;">Submitted Hours</th>-->
                            <th style="width: 13%;">IN TIME PROS TIME</th>
                            <th style="width: 7%;">Arrived At</th>
                            <th style="width: 7%;">Left At</th>
                            <th style="width: 7%;"> At Work</th>
                            <th>Currently Using</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-teamDetails>
                        <tr [ngClass]="'textcolor'">
                            <td>
                                <div class="d-flex">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex justify-content-center align-items-end bg-primary-o-40 rounded w-100">
                                            <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />

                                        </div>
                                    </div>
                                    <div class="d-flex flex-column ml-3 justify-content-center">
                                        <div class="font-weight-bold">{{teamDetails.MemberName}} <i style=" font-size: 8px; color: #243A5E;"> joined on Dec 12, 2020</i></div>
                                        <div class="font-size-xs">.NET Developer</div>
                                        <div class="font-size-14">


                                            <span class="label label-dot label-primary"></span>
                                            <span class="ml-2">Working</span>

                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex">
                                    <div class="d-flex align-items-center">

                                        <div class="symbol symbol-35 symbol-warning" [ngClass]="{'symbol-warning':teamDetails.ProjectName== 'ATP jobs','symbol-success':teamDetails.ProjectName== 'ITP','symbol-primary':teamDetails.ProjectName== 'WFM One', 'symbol-info':teamDetails.ProjectName== 'CIC'}">
                                            <div class="symbol-label font-weight-boldest">{{ teamDetails.ProjectName | slice:0:3 }}</div>

                                        </div>
                                    </div>
                                    <div class="d-flex flex-column ml-3 justify-content-center">
                                        <div class="font-weight-bold">{{ teamDetails.ProjectName }}</div>
                                    </div>
                                </div>

                            </td>
                            <td>
                                {{teamDetails.ProductiveTime}}
                            </td>
                            <td>
                                {{teamDetails.ITPTime}}
                            </td>
                            <td>
                                {{teamDetails.ArrivedAt}}
                            </td>
                            <td>
                                {{teamDetails.LeftAt}}
                            </td>
                            <td>
                                {{teamDetails.AtWork}}
                            </td>
                            <td>
                                <span class="label  rounded-pill h-35px label-inline mr-2 w-160px border h-40px justify-content-start" [ngClass]="{'bg-success-o-40': teamDetails.proStatus === 'Productive', 'border-success': teamDetails.proStatus === 'Productive',
                                     'bg-danger-o-40': teamDetails.currentlyusing === 'Absent', 'border-danger': teamDetails.currentlyusing === 'Absent','bg-gray-100' : teamDetails.proStatus === 'Neutral', 'border-secondary' : teamDetails.proStatus === 'Neutral',
                                        'unproductiveColor': teamDetails.proStatus === 'Unproductive', 'unproductiveBackground': teamDetails.proStatus === 'Unproductive'}">
                                    <div class="d-flex">
                                        <div class="d-flex align-items-center cursor-pointer">
                                            <div class="d-flex justify-content-center align-items-end  rounded w-70">


                                                <img [src]="teamDetails.icon" class="mt-1 px-2 w-90 h-20px">


                                            </div>
                                        </div>
                                        <div class="d-flex flex-column cursor-pointer">
                                            <div class="font-weight-bold mt-1 text-dark-75 font-size-sm">{{teamDetails.currentlyusing | slice:0:13}}{{teamDetails.currentlyusing?.length>13? '..': ''}}</div>
                                            <div class=" font-size-14" [ngClass]="{'text-success': teamDetails.proStatus === 'Productive'}"></div>


                                        </div>
                                    </div>
                                </span>
                            </td>

                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

    </div>


    <!--Team Details user Screenshot section-->
    <!--Team Details user Screenshot section-->
    <div class="row mt-3 mb-4 px-1" *ngIf="isShown_grid">



        <div class="col-md-4">
            <div class="card border rounded-0 shadow-sm h-475px rounded-0">

                <div class="row">
                    <div class="left-red-border"></div>

                    <div class="col-md-8">
                        <div class="d-flex pl-4 pt-4">
                            <div class="d-flex align-items-center">
                                <div class="d-flex justify-content-center align-items-end bg-primary-o-40 rounded w-100">
                                    <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />

                                </div>
                            </div>
                            <div class="d-flex flex-column ml-3 justify-content-center">
                                <div class="font-weight-bold">Deep Kakde</div>
                                <div class="font-size-xs">Deep@waiin.com</div>
                                <div class="font-size-14">


                                    <span class="label label-dot label-primary"></span>
                                    <span class="ml-2">Working</span>

                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="col-md-4">
                        <div class="text-center mt-6">
                            <span class="label bg-primary-o-40 label-lg label-inline mr-2"><span class="text-primary">Net Developer</span></span>

                        </div>
                    </div>


                </div>

                <div class="row pt-8 mb-4 no-gutters ml-1">


                    <div class="col-md-4">
                        <div class="d-flex flex-lg-fill" id="SymbolCustom">
                            <div class="symbol symbol-sm-30 symbol-warning mr-4 mt-5">
                                <div class="symbol-label font-weight-boldest">ATP</div>
                                <i class="symbol-badge bg-danger"></i>

                            </div>
                            <div class="d-flex flex-column mt-2">
                                <span class="font-size-sm mb-1 font-weight-bold">ATP Jobs</span>
                                <span class=" font-size-xs">Developing New Features</span>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-8 p-1">
                        <span class="label  rounded-pill h-50px  label-inline  border justify-content-start bg-success-o-40 border-success">
                            <div class="d-flex">
                                <div class="d-flex align-items-center cursor-pointer">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                                        <img src="../../../../../assets/common/images/Activities/AdobeIcon.png" width="20" />
                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-3">
                                    <div class="font-weight-bold text-dark-75 fontColor">Adobe XD</div>
                                    <div class=" font-size-14 text-success font-weight-bolder">Productive</div>
                                </div>
                                <div class="d-flex align-items-center cursor-pointer mt-2 ml-2">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                                        <img src="../../../../assets/common/images/device-icon/WindowsDesktopGrey.svg" width="20" />
                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-2 mt-2">
                                    <div class="font-weight-bold text-dark-75 fontColor">JAMES MACBOOK PRO</div>
                                </div>


                            </div>

                        </span>
                    </div>


                </div>


                <div class="row ml-2" id="textAlignment">
                    <div class="col-12">
                        <ul>
                            <li>
                                <div> <b class="text-success">6h 28m</b></div>
                                <small>Productive</small>
                            </li>

                            <li>
                                <div> <b class="text-primary">6h 28m</b></div>
                                <small>ITP Time</small>
                            </li>

                            <li>
                                <div> <b class="text-warning">09:30 AM</b></div>
                                <small>Arrived At</small>
                            </li>
                            <li>
                                <div> <b class="text-primary">-</b></div>
                                <small>Left At</small>
                            </li>
                            <li>
                                <div> <b class="text-info">7h 40m</b></div>
                                <small>At Work</small>
                            </li>
                        </ul>
                    </div>


                </div>


                <div class="row  overflow-hidden no-gutters">
                    <div class="col-md-12 ">
                        <div class="ml-7">
                            <img src="assets/common/images/Activities/screenshotIcon.png" alt="logo" class="h-auto w-325px" />
                        </div>
                    </div>


                </div>


                <div class="row mt-3 no-gutters ml-3">
                    <div class="col-md-1">

                        <img src="../../../../assets/common/images/Activities/Youtube.png" class="h-20px w-20px" />
                    </div>
                    <div class="col-md-10">
                        <small>youtube.com</small>
                    </div>

                </div>

                <div class="px-5 align-item-center row">
                    <div class="col-md-4 mt-1">
                        <small class="text-primary"> Steve Rogers</small>
                    </div>

                    <div class="col-md-2 mt-2">
                        <div class=" row">
                            <small class="text-danger"> 43.54%</small>
                        </div>


                    </div>
                    <div class="col-md-3 mt-2">
                        <div class=" row">
                            <small>43.54%</small>
                        </div>


                    </div>

                    <div class="col-md-3 mt-2">
                        <div class="text-center">
                            <h6 class="text-primary"> See All</h6>

                        </div>
                    </div>
                </div>

            </div>

        </div>


        <div class="col-md-4">
            <div class="card border rounded-0 shadow-sm h-475px rounded-0">

                <div class="row">
                    <div class="left-red-border"></div>

                    <div class="col-md-8">
                        <div class="d-flex pl-4 pt-4">
                            <div class="d-flex align-items-center">
                                <div class="d-flex justify-content-center align-items-end bg-primary-o-40 rounded w-100">
                                    <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="h-50px w-50px rounded" />

                                </div>
                            </div>
                            <div class="d-flex flex-column ml-3 justify-content-center">
                                <div class="font-weight-bold">Deep Kakde</div>
                                <div class="font-size-xs">Deep@waiin.com</div>
                                <div class="font-size-14">


                                    <span class="label label-dot label-primary"></span>
                                    <span class="ml-2">Working</span>

                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="col-md-4">
                        <div class="text-center mt-6">
                            <span class="label bg-primary-o-40 label-lg label-inline mr-2"><span class="text-primary">Net Developer</span></span>

                        </div>
                    </div>


                </div>

                <div class="row pt-8 mb-4 no-gutters ml-1">


                    <div class="col-md-4">
                        <div class="d-flex flex-lg-fill" id="SymbolCustom">
                            <div class="symbol symbol-sm-30 symbol-warning mr-4 mt-5">
                                <div class="symbol-label font-weight-boldest">ATP</div>
                                <i class="symbol-badge bg-danger"></i>

                            </div>
                            <div class="d-flex flex-column mt-2">
                                <span class="font-size-sm mb-1 font-weight-bold">ATP Jobs</span>
                                <span class=" font-size-xs">Developing New Features</span>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-8 p-1">
                        <span class="label  rounded-pill h-50px  label-inline  border justify-content-start bg-success-o-40 border-success">
                            <div class="d-flex">
                                <div class="d-flex align-items-center cursor-pointer">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                                        <img src="../../../../../assets/common/images/Activities/AdobeIcon.png" width="20" />
                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-3">
                                    <div class="font-weight-bold text-dark-75 fontColor">Adobe XD</div>
                                    <div class=" font-size-14 text-success font-weight-bolder">Productive</div>
                                </div>
                                <div class="d-flex align-items-center cursor-pointer mt-2 ml-2">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                                        <img src="../../../../assets/common/images/device-icon/WindowsDesktopGrey.svg" width="20" />
                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-2 mt-2">
                                    <div class="font-weight-bold text-dark-75 fontColor">JAMES MACBOOK PRO</div>
                                </div>


                            </div>

                        </span>
                    </div>


                </div>


                <div class="row ml-2" id="textAlignment">
                    <div class="col-12">
                        <ul>
                            <li>
                                <div> <b class="text-success">6h 28m</b></div>
                                <small>Productive</small>
                            </li>

                            <li>
                                <div> <b class="text-primary">6h 28m</b></div>
                                <small>ITP Time</small>
                            </li>

                            <li>
                                <div> <b class="text-warning">09:30 AM</b></div>
                                <small>Arrived At</small>
                            </li>
                            <li>
                                <div> <b class="text-primary">-</b></div>
                                <small>Left At</small>
                            </li>
                            <li>
                                <div> <b class="text-info">7h 40m</b></div>
                                <small>At Work</small>
                            </li>
                        </ul>
                    </div>


                </div>


                <div class="row  overflow-hidden no-gutters">
                    <div class="col-md-12 ">
                        <div class="ml-7">
                            <img src="assets/common/images/Activities/screenshotIcon.png" alt="logo" class="h-auto w-325px" />
                        </div>
                    </div>


                </div>


                <div class="row mt-3 no-gutters ml-3">
                    <div class="col-md-1">

                        <img src="../../../../assets/common/images/Activities/Youtube.png" class="h-20px w-20px" />
                    </div>
                    <div class="col-md-10">
                        <small>youtube.com</small>
                    </div>

                </div>

                <div class="px-5 align-item-center row">
                    <div class="col-md-4 mt-1">
                        <small class="text-primary"> Steve Rogers</small>
                    </div>

                    <div class="col-md-2 mt-2">
                        <div class=" row">
                            <small class="text-danger"> 43.54%</small>
                        </div>


                    </div>
                    <div class="col-md-3 mt-2">
                        <div class=" row">
                            <small>43.54%</small>
                        </div>


                    </div>

                    <div class="col-md-3 mt-2">
                        <div class="text-center">
                            <h6 class="text-primary"> See All</h6>

                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="col-md-4">
            <div class="card border rounded-0 shadow-sm h-475px rounded-0">

                <div class="row">
                    <div class="left-red-border"></div>

                    <div class="col-md-8">
                        <div class="d-flex pl-4 pt-4">
                            <div class="d-flex align-items-center">
                                <div class="d-flex justify-content-center align-items-end bg-primary-o-40 rounded w-100">
                                    <img src="../../../../assets/common/images/time-sheet/boy_pic.png" class="m-1 h-50px w-50px rounded" />

                                </div>
                            </div>
                            <div class="d-flex flex-column ml-3 justify-content-center">
                                <div class="font-weight-bold">Deep Kakde</div>
                                <div class="font-size-xs">Deep@waiin.com</div>
                                <div class="font-size-14">


                                    <span class="label label-dot label-primary"></span>
                                    <span class="ml-2">Working</span>

                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="col-md-4">
                        <div class="text-center mt-6">
                            <span class="label bg-primary-o-40 label-lg label-inline mr-2"><span class="text-primary">Net Developer</span></span>

                        </div>
                    </div>


                </div>

                <div class="row pt-8 mb-4 no-gutters ml-1">


                    <div class="col-md-4">
                        <div class="d-flex flex-lg-fill" id="SymbolCustom">
                            <div class="symbol symbol-sm-30 symbol-warning mr-4 mt-5">
                                <div class="symbol-label font-weight-boldest">ATP</div>
                                <i class="symbol-badge bg-danger"></i>

                            </div>
                            <div class="d-flex flex-column mt-2">
                                <span class="font-size-sm mb-1 font-weight-bold">ATP Jobs</span>
                                <span class=" font-size-xs">Developing New Features</span>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-8 p-1">
                        <span class="label  rounded-pill h-50px  label-inline  border justify-content-start bg-success-o-40 border-success">
                            <div class="d-flex">
                                <div class="d-flex align-items-center cursor-pointer">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                                        <img src="../../../../../assets/common/images/Activities/AdobeIcon.png" width="20" />
                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-3">
                                    <div class="font-weight-bold text-dark-75 fontColor">Adobe XD</div>
                                    <div class=" font-size-14 text-success font-weight-bolder">Productive</div>
                                </div>
                                <div class="d-flex align-items-center cursor-pointer mt-2 ml-2">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                                        <img src="../../../../assets/common/images/device-icon/WindowsDesktopGrey.svg" width="20" />
                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-2 mt-2">
                                    <div class="font-weight-bold text-dark-75 fontColor">JAMES MACBOOK PRO</div>
                                </div>


                            </div>

                        </span>
                    </div>


                </div>


                <div class="row ml-2" id="textAlignment">
                    <div class="col-12">
                        <ul>
                            <li>
                                <div> <b class="text-success">6h 28m</b></div>
                                <small>Productive</small>
                            </li>

                            <li>
                                <div> <b class="text-primary">6h 28m</b></div>
                                <small>ITP Time</small>
                            </li>

                            <li>
                                <div> <b class="text-warning">09:30 AM</b></div>
                                <small>Arrived At</small>
                            </li>
                            <li>
                                <div> <b class="text-primary">-</b></div>
                                <small>Left At</small>
                            </li>
                            <li>
                                <div> <b class="text-info">7h 40m</b></div>
                                <small>At Work</small>
                            </li>
                        </ul>
                    </div>


                </div>


                <div class="row  overflow-hidden no-gutters">
                    <div class="col-md-12 ">
                        <div class="ml-7">
                            <img src="assets/common/images/Activities/screenshotIcon.png" alt="logo" class="h-auto w-325px" />
                        </div>
                    </div>


                </div>


                <div class="row mt-3 no-gutters ml-3">
                    <div class="col-md-1">

                        <img src="../../../../assets/common/images/Activities/Youtube.png" class="h-20px w-20px" />
                    </div>
                    <div class="col-md-10">
                        <small>youtube.com</small>
                    </div>

                </div>

                <div class="px-5 align-item-center row">
                    <div class="col-md-4 mt-1">
                        <small class="text-primary"> Steve Rogers</small>
                    </div>

                    <div class="col-md-2 mt-2">
                        <div class=" row">
                            <small class="text-danger"> 43.54%</small>
                        </div>


                    </div>
                    <div class="col-md-3 mt-2">
                        <div class=" row">
                            <small>43.54%</small>
                        </div>


                    </div>

                    <div class="col-md-3 mt-2">
                        <div class="text-center">
                            <h6 class="text-primary"> See All</h6>

                        </div>
                    </div>
                </div>

            </div>

        </div>



    </div>







</div>
